// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import bg from 'vee-validate/dist/locale/bg';
import App from './App'
import store from './store'
import router from './router'
import VuesticPlugin from '@/vuestic-theme/vuestic-plugin'
import './i18n'
import YmapPlugin from 'vue-yandex-maps'

import { auth } from './services/api/auth'
import axios from 'axios'

import { TokenStorage } from "../src/services/token"
import moment, { min } from 'moment';
import JsonCSV from 'vue-json-csv'
 
Vue.component('downloadCsv', JsonCSV)
Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })
Validator.localize('bg', bg)

import { ToggleButton } from 'vue-js-toggle-button'

Vue.component('ToggleButton', ToggleButton)

import utils from './utils.js';

Vue.config.productionTip = false;
Vue.config.devtools = false;

const plugin = {
  install(Vue, options) {
    Vue.prototype.$utils = utils;
  }
};

Vue.use(plugin);

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
  checkForNewToken()
})

/* eslint-disable no-new */

async function devAutoLogin() {
  const user = await auth.login('test@test.com', 'test123')
  store.commit('user', user)
}

let lastRefresh = moment();
let isCurrentlyRefreshing = false;

axios.interceptors.request.use(function (config) {
  if (TokenStorage.isAuthenticated()) {
    let auth = TokenStorage.getAuthentication();
    config.headers = {
      ...config.headers,
      ...auth
    }
  }

  checkForNewToken()
  .catch((error) => {
    Promise.reject(error);
  });

  return config;
}, function (err) {
  return Promise.reject(err);
});

let checkForNewToken = ()=>{
  var duration = moment().diff(lastRefresh, "minutes");
  console.log("Check for new token ",duration);
  if (duration >= 45 && !isCurrentlyRefreshing) {
    isCurrentlyRefreshing = true;
    return TokenStorage.getNewToken()
      .then((token) => {
        lastRefresh = moment();
        isCurrentlyRefreshing = false;
      })
  }else{
    return Promise.resolve();
  }
}


axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response.status !== 401) {
    return Promise.reject(error);
  }else{
    TokenStorage.clear();
    router.push('/login');
    return Promise.reject(error);
  }
});

async function init() {
  // await devAutoLogin()
  if (TokenStorage.isAuthenticated()){
    TokenStorage.getNewToken();
  }

  Vue.prototype.$http = axios

  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
  })
}

init()
